import * as React from "react";
const SvgPlayArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 5v14l11-7z" }));
export default SvgPlayArrow;
